// extracted by mini-css-extract-plugin
export default {"STIcons":"style_STIcons__vl3m6","STPopper":"style_STPopper__jf0R6","Icon":"style_Icon__c-b-G"};